document.addEventListener('DOMContentLoaded', () => {

  // =============================================================
  //  NAWIGACJA
  // =============================================================

  const nav         = document.getElementById('nav');
  const hamburger   = document.getElementById('navHamburger');
  const mobileMenu  = document.getElementById('navMobile');
  const mobileLinks = document.querySelectorAll('.nav__mobile-link');
  const mobileItems = document.querySelectorAll('.nav__mobile-link, .nav__mobile-phone');
  const sections    = document.querySelectorAll('section[id]');
  const navLinks    = document.querySelectorAll('.nav__link');


  // --- HAMBURGER TOGGLE --------------------------------------

  hamburger.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('nav__mobile--open');
    hamburger.setAttribute('aria-expanded', isOpen);
    mobileMenu.setAttribute('aria-hidden', !isOpen);

    mobileItems.forEach(item => {
      item.setAttribute('tabindex', isOpen ? '0' : '-1');
    });
  });


  // --- ZAMKNIJ MENU ----------------------------------------

  function closeMenu() {
    mobileMenu.classList.remove('nav__mobile--open');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileItems.forEach(item => item.setAttribute('tabindex', '-1'));
  }


  // --- ZAMKNIJ PO KLIKNIĘCIU W LINK ------------------------
  // Scroll obsługujemy ręcznie żeby uwzględnić wysokość navu

  mobileLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href');
      const target   = document.querySelector(targetId);

      closeMenu();

      if (target) {
        // czekamy aż menu się zwinie (transition 0.3s) potem scrollujemy
        setTimeout(() => {
          const navHeight = nav.offsetHeight;
          const targetTop = target.getBoundingClientRect().top + window.scrollY - navHeight;
          window.scrollTo({ top: targetTop, behavior: 'smooth' });
        }, 320);
      }
    });
  });


  // --- ZAMKNIJ PO KLIKNIĘCIU POZA MENU ---------------------

  document.addEventListener('click', (e) => {
    if (!mobileMenu.classList.contains('nav__mobile--open')) return;
    if (!nav.contains(e.target)) {
      closeMenu();
    }
  });


  // --- CIEŃ NA NAVIE PO SCROLLU -----------------------------

  const handleScroll = () => {
    if (window.scrollY > 10) {
      nav.classList.add('nav--scrolled');
    } else {
      nav.classList.remove('nav--scrolled');
    }

    // --- AKTYWNY LINK PRZY SCROLLOWANIU --------------------
    // Sprawdza która sekcja jest aktualnie widoczna i dodaje klasę --active

    let currentSection = '';

    sections.forEach(section => {
      const sectionTop    = section.offsetTop - 80; // offset = wysokość navu
      const sectionHeight = section.offsetHeight;

      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        currentSection = section.getAttribute('id');
      }
    });

    navLinks.forEach(link => {
      link.classList.remove('nav__link--active');
      if (link.getAttribute('href') === `#${currentSection}`) {
        link.classList.add('nav__link--active');
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });


  // =============================================================
  //  GALERIA — LIGHTBOX
  // =============================================================

  // const lightbox      = document.getElementById('lightbox');
  // const lightboxImg   = document.getElementById('lightboxImg');
  // const lightboxClose = document.getElementById('lightboxClose');
  // const galleryItems  = document.querySelectorAll('.gallery__item');


  // --- OTWÓRZ LIGHTBOX ---------------------------------------

  // galleryItems.forEach(item => {
  //   item.addEventListener('click', () => {
  //     const src = item.getAttribute('data-src');
  //     const alt = item.getAttribute('data-alt');

  //     lightboxImg.setAttribute('src', src);
  //     lightboxImg.setAttribute('alt', alt);

  //     lightbox.classList.add('lightbox--open');
  //     lightboxClose.focus();
  //     document.body.style.overflow = 'hidden'; // blokuj scroll pod lightboxem
  //   });
  // });


  // --- ZAMKNIJ LIGHTBOX — przycisk -------------------------

  // lightboxClose.addEventListener('click', closeLightbox);


  // --- ZAMKNIJ LIGHTBOX — klik w tło -----------------------

  // lightbox.addEventListener('click', (e) => {
  //   if (e.target === lightbox) {
  //     closeLightbox();
  //   }
  // });


  // --- ZAMKNIJ LIGHTBOX — klawisz Escape ------------------

  // document.addEventListener('keydown', (e) => {
  //   if (e.key === 'Escape' && lightbox.classList.contains('lightbox--open')) {
  //     closeLightbox();
  //   }
  // });


  // --- FUNKCJA ZAMKNIĘCIA ----------------------------------

  // function closeLightbox() {
  //   lightbox.classList.remove('lightbox--open');
  //   lightboxImg.setAttribute('src', '');
  //   lightboxImg.setAttribute('alt', '');
  //   document.body.style.overflow = '';
  // }


  // =============================================================
  //  OPINIE — SLIDER
  // =============================================================

  const track     = document.getElementById('reviewsTrack');
  const prevBtn   = document.getElementById('reviewsPrev');
  const nextBtn   = document.getElementById('reviewsNext');
  const dotsWrap  = document.getElementById('reviewsDots');
  const cards     = track ? Array.from(track.querySelectorAll('.review')) : [];

  let currentIndex = 0;
  let visibleCount = 1;
  let startX = 0;
  let isDragging = false;

  // --- ILE KART WIDOCZNYCH ---------------------------------

  function getVisibleCount() {
    if (window.innerWidth >= 993) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }

  // --- MAKSYMALNY INDEX ------------------------------------

  function getMaxIndex() {
    return Math.max(0, cards.length - visibleCount);
  }

  // --- PRZESUŃ SLIDER --------------------------------------

  function goTo(index) {
    visibleCount = getVisibleCount();
    currentIndex = Math.max(0, Math.min(index, getMaxIndex()));

    const cardWidth  = cards[0].offsetWidth;
    const gap        = 16; // 1.6rem = 16px
    const offset     = currentIndex * (cardWidth + gap);

    track.style.transform = `translateX(-${offset}px)`;

    updateDots();
    updateButtons();
  }

  // --- DOTS ------------------------------------------------

  function buildDots() {
    visibleCount = getVisibleCount();
    dotsWrap.innerHTML = '';
    const total = getMaxIndex() + 1;

    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.classList.add('reviews-slider__dot');
      dot.setAttribute('aria-label', `Opinia ${i + 1}`);
      if (i === currentIndex) dot.classList.add('reviews-slider__dot--active');
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
    }
  }

  function updateDots() {
    const dots = dotsWrap.querySelectorAll('.reviews-slider__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('reviews-slider__dot--active', i === currentIndex);
    });
  }

  function updateButtons() {
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
  }

  // --- STRZAŁKI --------------------------------------------

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

  // --- SWIPE (touch) ---------------------------------------

  if (track) {
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
      }
      isDragging = false;
    }, { passive: true });
  }

  // --- RESIZE — przelicz przy zmianie rozmiaru okna --------

  window.addEventListener('resize', () => {
    buildDots();
    goTo(currentIndex);
  });

  // --- INIT ------------------------------------------------

  if (track && cards.length) {
    buildDots();
    goTo(0);
  }


  // =============================================================
  //  FAQ — ACCORDION
  // =============================================================

  const faqItems = document.querySelectorAll('.faq__item');

  faqItems.forEach(item => {
    const btn    = item.querySelector('.faq__question');
    const answer = item.querySelector('.faq__answer');

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      // zamknij wszystkie inne
      faqItems.forEach(other => {
        other.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        other.querySelector('.faq__answer').classList.remove('faq__answer--open');
      });

      // otwórz kliknięty jeśli był zamknięty
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.classList.add('faq__answer--open');
      }
    });
  });


  // =============================================================
  //  ROK W STOPCE
  // =============================================================

  const yearEl = document.getElementById('footerYear');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  
});